import React from "react";
import {useTranslation} from "react-i18next";
import Modal from "./Modal";
import styles from "./Modal.module.scss";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import {GtinItem} from "@connox/typescript-library";
import BasketModalBoughtTogetherSwiper from "../../organisms/crossSelling/BasketModalBoughtTogetherSwiper";
import ErrorBoundary from "../../utils/ErrorBoundary";

interface IAddToCartProps {
  closeFunction: () => void;
  isVisible: boolean;
  itemIds: GtinItem[];
  toCartFunction: () => void;
}

const AddToCartModal: React.FC<IAddToCartProps> = (props) => {
  const {t} = useTranslation();
  const context = useUnsafeCartContext();
  const {itemIds} = props;

  if (!itemIds.length || !isCart(context)) {
    return null;
  }

  const positions = context.cart.positions.filter((pos) => {
    return (
      pos.type === "Item" &&
      pos.reference &&
      pos.reference.itemId !== null &&
      pos.item &&
      itemIds.some(
        ({itemId, gtin}) => itemId === pos.item?.itemId || gtin === (pos.item?.registrationNumber ?? undefined),
      )
    );
  });

  const Content: React.FC = () => (
    <div className={styles.content}>
      <table>
        <tbody>
          {positions.map((pos) => {
            if (!pos.item) {
              return;
            }
            const imgUrl = pos.item.images[0].sizes.find((img) => img.name === "thumbnail-3x")?.url;

            return (
              <tr key={pos.item.itemId}>
                <td style={{width: "98px"}}>
                  <img src={imgUrl} alt={pos.item.title} width="90px" />
                </td>
                <td>{t("general.addedToShoppingCart--title", {title: pos.item.title})}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const toCart = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();
    props.toCartFunction();
  };

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{t("general.goodChoice")}</h2>
      <Content />
      <div className={styles.anchorDiv}>
        <a href="#" onClick={toCart} className="button">
          {t("cart.toShoppingCart")}
        </a>
      </div>
      {typeof itemIds[0].itemId === "number" && (
        <ErrorBoundary fallback={null} occurrence="AddToCartModal">
          <BasketModalBoughtTogetherSwiper itemId={itemIds[0].itemId} />
        </ErrorBoundary>
      )}
    </Modal>
  );
};

export default AddToCartModal;
